import { useTranslation } from 'react-i18next'
import { IconHeart } from './AppNavIcons'

type Props = {
  onLogin: () => void
  onBrowse?: () => void
}

export default function FavoritesGuestGate({ onLogin, onBrowse }: Props) {
  const { t } = useTranslation()

  return (
    <section className="favorites-page favorites-page--modern">
      <div className="favorites-empty favorites-empty--bloom">
        <div className="favorites-empty__glow" aria-hidden="true" />
        <div className="favorites-empty__icon" aria-hidden="true">
          <IconHeart />
        </div>
        <p className="favorites-empty__title">{t('vc.favorites.membersOnlyTitle')}</p>
        <p className="favorites-empty__hint">{t('vc.favorites.membersOnlyBody')}</p>
        <div className="favorites-empty__actions">
          <button type="button" className="favorites-empty__cta" onClick={onLogin}>
            {t('vc.favorites.membersOnlyCta')}
          </button>
          {onBrowse ? (
            <button type="button" className="favorites-empty__cta favorites-empty__cta--secondary" onClick={onBrowse}>
              {t('vc.favorites.browseCta')}
            </button>
          ) : null}
        </div>
      </div>
    </section>
  )
}
